import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../component/Header";
import { useSwal } from "../../component/sweetalert";
import "../AddBlog/index.css";
import api from "../../Services/api";

export default function AddExeFileUpload() {
  const [name, setName] = useState("");
  const [version, setVersion] = useState("");
  const [description, setDescription] = useState("");
  const [exeFile, setExeFile] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const alert = useSwal();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleExeChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.name.toLowerCase().endsWith(".exe") && file.type !== "application/octet-stream") {
        alert("error", "Please select a valid EXE file.");
        return;
      }
      setExeFile(file);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/svg+xml", "image/webp"];
    if (file) {
      if (!validTypes.includes(file.type)) {
        alert("error", "Please select a valid image file (SVG, JPG, PNG, WEBP).");
        return;
      }
      setImageFile(file);
    }
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!name || !exeFile) {
      alert("error", "Please provide a product name and an EXE file.");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("version", version);
    formData.append("description", description);
    formData.append("exeFile", exeFile);
    formData.append("exe", exeFile);
    if (imageFile) {
      formData.append("imageFile", imageFile);
      formData.append("image", imageFile);
    }

    try {
      await api.post("/insertDownload", formData);

      alert("success", "Add Download successfully!");
      navigate("/exe-uploads");
    } catch (error) {
      console.error("❌ Error uploading file:", error);
      alert("error", "Failed to upload file.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="dashboardpage">
      <Header pageTitle="Upload New Exe File" backTo="/exe-uploads"/>
      <div className="pageLeftspace">    
      <div className="d-flex justify-content-start col-xl-6 col-12">
        {/* Form Section */}
        <form className="form-fields d-flex" onSubmit={handleSubmit}>
          <div className="grid-container user">
            {/* Product Name Input */}
            <div className="input-container">
              <input
                type="text"
                id="name"
                placeholder="Enter EXE Product Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <span className="underline"></span>
            </div>

            {/* Version Input */}
            <div className="input-container">
              <input
                type="text"
                id="version"
                placeholder="Enter File Version"
                value={version}
                onChange={(e) => setVersion(e.target.value)}
              />
              <span className="underline"></span>
            </div>

            {/* Description Input */}
            <div className="input-container description-container">
              <textarea
                id="description"
                placeholder="Enter File Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <span className="underline"></span>
            </div>

            {/* EXE File Upload */}
            <div className="input-container file-input-container">
              <label htmlFor="exeUpload" className="file-label">Upload EXE file</label>
              <input
                type="file"
                id="exeUpload"
                onChange={handleExeChange}
                className="file-input"
                accept=".exe"
                required
              />
              <span className="underline"></span>
              {exeFile && <p className="file-name">EXE: {exeFile.name}</p>}
            </div>

            {/* Image File Upload */}
            <div className="input-container file-input-container">
              <label htmlFor="imageUpload" className="file-label">Upload image file</label>
              <input
                type="file"
                id="imageUpload"
                onChange={handleImageChange}
                className="file-input"
                accept=".svg,.jpg,.jpeg,.png,.webp"
              />
              <span className="underline"></span>
              {imageFile && <p className="file-name">Image: {imageFile.name}</p>}
            </div>

            <button className="btn btn-purpal" type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          
          </div>

          {/* Submit Button */}
    
        </form>
        </div>
      </div>
    </section>
  );
}
